import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../../../styles'
import { IntlShape, useIntl } from 'react-intl'
import langEnum from '../../../../../enums/langEnum'
import classNames from 'classnames'
import DocPdf from './DocPdf'
import { ModelDoc } from '../docs_model'

const useStyle = makeStyles((theme) => ({
	...styles(theme),
	cardContainer: {
		display: 'flex',
		padding: '16px 0px',
		borderTop: `1px solid ${theme.palette.blue['10']}`
	},
	divFlex: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between'
	},
	flexDirectionRow: {
		flexDirection: 'row'
	},
	flexDirectionColumn: {
		flexDirection: 'column'
	}
}))

interface AcceptingProps {
	doc: ModelDoc,
}

type CardDocProps = AcceptingProps

const CardDoc: React.FC<CardDocProps> = (
	{
		doc,
	}
) => {
	const classes = useStyle()
	const intl: IntlShape = useIntl()

	const cardContainerClass = classNames(
		classes.cardContainer,
		classes.flexDirectionColumn
	)

	const renommageClass = classNames(
		classes.colorBlue,
		classes.semiBold
	)

	const dateClass = classNames(
		classes.text9_opacity,
		classes.medium,
		classes.colorBlue
	)

	const documentTypeClass = classNames(
		classes.text8,
		classes.semiBold,
		classes.colorBlue
	)

    return (
        <div className={cardContainerClass} key={doc.id}>
			<span className={dateClass}>
				{doc.dwstoredatetime.toLocaleDateString()}
			</span>
			<div className={classes.divFlex}>
				<span className={documentTypeClass}>
					<span className={renommageClass}>
					{(intl.locale === langEnum.fr) ? doc.renommage_fr : doc.renommage_en}
					</span> - {doc.titre_object}
				</span>
				<DocPdf doc={doc} />
			</div>

		</div>
	)
}

export default CardDoc